import React from 'react';

// Themes
import CssBaseline from '@mui/material/CssBaseline';

// Routes
import { Routes, Route, Outlet, Link } from 'react-router-dom';

// Pages
import AppBar from './AppBar'

function Home() {
    return (
	<div>
            <CssBaseline />
	    <AppBar />
	    <Outlet />
	</div>
    );
}

export default Home;
